import {FC} from "react";
import styled from "styled-components";
import {useSelector} from "react-redux";
import {chain, get, map} from "lodash";
import {getUserAchievements} from "modules/selectors";
import {IAchievement} from "modules/reducers";
import {IBadgesFilters} from "modules/types";
import {useIsMobile} from "modules/utils";
import {BadgeModal, BadgesGameList} from "components";

const Wrapper = styled.div`
	display: grid;
	grid-template-rows: auto;
	grid-row-gap: 32px;
	grid-column-gap: 28px;
	color: ${({theme}) => theme.color.tertiary};
	grid-template-columns: 1fr;
	max-width: 1340px;
	margin: 0 auto;
	width: 100%;

	@media (min-width: 769px) {
		grid-template-columns: 1fr;
		padding: 0 44px 120px;
	}

	@media (min-width: 1200px) {
		grid-template-columns: 1fr 1fr;
	}
`;

interface IBadgesList {
	filters: IBadgesFilters;
}

export const BadgesList: FC<IBadgesList> = ({filters}) => {
	const {isMobile} = useIsMobile();
	const achievements = useSelector(getUserAchievements);

	const list = chain(achievements)
		.reduce<Record<string, IAchievement[]>>((acc, achievement) => {
			const array = get(acc, achievement.game, []);

			acc[achievement.game] = [...array, achievement];
			return acc;
		}, {})
		.map((achievements, game) => ({game, achievements}))
		.orderBy(({game}): void | boolean => {
			if (isMobile) {
				return game === filters.game;
			}
		}, "desc")
		.value();

	return (
		<Wrapper>
			{map(list, ({game, achievements}) => (
				<BadgesGameList
					key={game}
					achievements={achievements}
					game={game}
					filters={filters}
				/>
			))}
			<BadgeModal />
		</Wrapper>
	);
};
